import React from "react";
import parse from "html-react-parser";
import { useFaq } from "..";
import { LoadingSpinner } from "shared";

export const FrequentlyQuestions = () => {
  const { settingsInfo } = useFaq({
    load: true,
    key: "page_FAQ",
  });
  const { data, isLoading } = settingsInfo;

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="terms-faq-privacy-section">
      <div className="page-header-left col-12 col-md-8 pb-5">
        <h2 className="page-title ellipsis-text">Frequently Asked Questions</h2>
      </div>
      <p>{data ? parse(data?.content) : ""}</p>
    </div>
  );
};
